import React, { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'
import { C } from '../theme'
import vsLogo from '../assets/vs-logo.png'

const ALLE_SCHRITTE = [
  { nr: 1, name: 'Übernahme' },
  { nr: 2, name: 'Ersatzteile' },
  { nr: 3, name: 'Demontage' },
  { nr: 4, name: 'Lackvorbereitung' },
  { nr: 5, name: 'Lackierung' },
  { nr: 6, name: 'Lackkontrolle' },
  { nr: 7, name: 'Montage' },
  { nr: 8, name: 'Politur' },
  { nr: 9, name: 'Aufbereitung' },
  { nr: 10, name: 'Übergabe' },
]

const CSS = `
  * { box-sizing: border-box; }
  @keyframes ringPulse {
    0%,100% { box-shadow: 0 0 0 0 rgba(255,192,0,0.55); }
    50%     { box-shadow: 0 0 0 7px rgba(255,192,0,0); }
  }
`

function getTage(eingang) {
  return Math.floor((new Date() - new Date(eingang)) / 86400000)
}

function getDeadlineDiff(wunschdatum) {
  if (!wunschdatum) return null
  return Math.floor((new Date(wunschdatum) - new Date()) / 86400000)
}

/* ── Weiter Modal ── */
function WeiterModal({ fahrzeug, mitarbeiter, onClose, onDone }) {
  const [loading, setLoading]             = useState(false)
  const [kuerzel, setKuerzel]             = useState('')
  const [übergabeOk, setÜbergabeOk]      = useState(false)
  const [übergabeDatum, setÜbergabeDatum] = useState(new Date().toISOString().split('T')[0])
  const schritt  = fahrzeug.schritt
  const naechster = ALLE_SCHRITTE[schritt]?.name

  const weiter = async () => {
    if (loading) return
    if (schritt === 10 && !übergabeOk) { alert('Bitte Übergabe bestätigen!'); return }
    setLoading(true)
    if (schritt === 10) {
      await supabase.from('fahrzeuge').update({ übergabe_ok: true, übergabe_datum: übergabeDatum }).eq('id', fahrzeug.id)
      await supabase.from('schritt_historie').insert({ fahrzeug_id: fahrzeug.id, schritt, typ: 'übergabe', text: `✅ Übergeben am ${new Date(übergabeDatum).toLocaleDateString('de-DE')}`, mitarbeiter })
    } else {
      const update = { schritt: schritt + 1, problem: false }
      if (schritt === 3 && kuerzel) update.mitarbeiter = kuerzel
      await supabase.from('fahrzeuge').update(update).eq('id', fahrzeug.id)
      await supabase.from('schritt_historie').insert({ fahrzeug_id: fahrzeug.id, schritt, typ: 'schritt', text: `✓ ${ALLE_SCHRITTE[schritt - 1].name} abgeschlossen${kuerzel ? ` [${kuerzel}]` : ''}`, mitarbeiter })
    }
    setLoading(false)
    onDone()
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 400, padding: 16 }}>
      <div style={{ background: '#fff', borderRadius: 16, padding: 28, width: '100%', maxWidth: 400, boxShadow: '0 16px 48px rgba(0,0,0,0.35)' }}>
        <div style={{ fontSize: 24, fontWeight: 900, color: '#111', marginBottom: 4 }}>{fahrzeug.kennzeichen}</div>
        <div style={{ fontSize: 14, color: '#6b7280', marginBottom: 20 }}>
          Schritt {schritt}: <strong>{ALLE_SCHRITTE[schritt - 1]?.name}</strong>
          {naechster && <> → {naechster}</>}
        </div>
        {schritt === 3 && (
          <div style={{ marginBottom: 16 }}>
            <label style={ml}>Mitarbeiter-Kürzel</label>
            <input style={mi} placeholder="z.B. JS" maxLength={4} value={kuerzel} onChange={e => setKuerzel(e.target.value.toUpperCase())} autoComplete="off" />
          </div>
        )}
        {schritt === 10 && (
          <div style={{ marginBottom: 16 }}>
            <label style={ml}>Übergabedatum</label>
            <input type="date" style={mi} value={übergabeDatum} onChange={e => setÜbergabeDatum(e.target.value)} />
            <label style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 12, cursor: 'pointer', fontSize: 16 }}>
              <input type="checkbox" checked={übergabeOk} onChange={e => setÜbergabeOk(e.target.checked)} style={{ width: 22, height: 22 }} />
              Übergabe bestätigen
            </label>
          </div>
        )}
        <button onClick={weiter} disabled={loading} style={{
          width: '100%', height: 52, border: 'none', borderRadius: 12,
          background: loading ? '#9ca3af' : schritt === 10 ? '#16a34a' : C.primary,
          color: loading || schritt === 10 ? '#fff' : C.onPrimary, fontSize: 17, fontWeight: 800,
          cursor: loading ? 'not-allowed' : 'pointer', marginBottom: 10,
        }}>
          {loading ? 'Speichern...' : schritt === 10 ? '✓ Übergabe abschließen' : `→ Weiter zu Schritt ${schritt + 1}`}
        </button>
        <button onClick={onClose} disabled={loading} style={{
          width: '100%', height: 44, border: '1.5px solid #e5e7eb', borderRadius: 12,
          background: '#fff', color: '#6b7280', fontSize: 15, fontWeight: 600, cursor: 'pointer',
        }}>Abbrechen</button>
      </div>
    </div>
  )
}

/* ── Login Modal — Benutzername statt E-Mail ── */
function LoginModal({ onSuccess, onClose }) {
  const [benutzername, setBenutzername] = useState('')
  const [password, setPassword]         = useState('')
  const [error, setError]               = useState('')
  const [loading, setLoading]           = useState(false)

  const login = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)

    const { data: benutzer, error: lookupErr } = await supabase
      .from('benutzer')
      .select('email')
      .eq('benutzername', benutzername.trim().toLowerCase())
      .single()

    if (lookupErr || !benutzer) {
      setError('Benutzername nicht gefunden.')
      setLoading(false)
      return
    }

    const { error: authErr } = await supabase.auth.signInWithPassword({ email: benutzer.email, password })
    if (authErr) { setError('Falsches Passwort.'); setLoading(false) }
    else onSuccess()
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.75)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 400, padding: 16 }}>
      <div style={{ background: '#fff', borderRadius: 16, padding: 28, width: '100%', maxWidth: 360, boxShadow: '0 16px 48px rgba(0,0,0,0.35)' }}>
        <div style={{ fontSize: 18, fontWeight: 800, marginBottom: 20 }}>Anmelden</div>
        <form onSubmit={login}>
          <div style={{ marginBottom: 14 }}>
            <label style={ml}>Benutzername</label>
            <input style={mi} type="text" value={benutzername} onChange={e => setBenutzername(e.target.value)} autoCapitalize="none" autoComplete="username" required />
          </div>
          <div style={{ marginBottom: 18 }}>
            <label style={ml}>Passwort</label>
            <input style={mi} type="password" value={password} onChange={e => setPassword(e.target.value)} required />
          </div>
          {error && <div style={{ background: '#fff5f5', color: '#c53030', borderRadius: 8, padding: '8px 12px', marginBottom: 14, fontSize: 13 }}>⚠ {error}</div>}
          <button type="submit" disabled={loading} style={{
            width: '100%', height: 48, border: 'none', borderRadius: 12,
            background: loading ? '#9ca3af' : C.primary, color: loading ? '#fff' : C.onPrimary,
            fontSize: 16, fontWeight: 800, cursor: loading ? 'not-allowed' : 'pointer', marginBottom: 10,
          }}>
            {loading ? 'Anmelden...' : 'Anmelden'}
          </button>
          <button type="button" onClick={onClose} style={{ width: '100%', height: 40, border: '1.5px solid #e5e7eb', borderRadius: 12, background: '#fff', color: '#9ca3af', fontSize: 14, cursor: 'pointer' }}>
            Abbrechen
          </button>
        </form>
      </div>
    </div>
  )
}

/* ── Schritt-Punkte ── */
function StepDots({ schritt }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      {ALLE_SCHRITTE.map(s => {
        const done   = schritt > s.nr
        const active = schritt === s.nr
        return (
          <div key={s.nr} style={{
            width: active ? 30 : 18, height: active ? 30 : 18, borderRadius: '50%',
            background: done ? C.primary : active ? 'transparent' : '#dbe3ec',
            border: active ? `3px solid ${C.primary}` : 'none',
            animation: active ? 'ringPulse 1.4s ease-out infinite' : 'none',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            flexShrink: 0, transition: 'all 0.25s',
            boxShadow: done ? '0 0 8px rgba(255,192,0,0.35)' : 'none',
          }}>
            {active && <span style={{ fontSize: 13, fontWeight: 900, color: C.primary }}>{s.nr}</span>}
          </div>
        )
      })}
    </div>
  )
}

const DISPLAY_PIN = process.env.REACT_APP_DISPLAY_PIN || '1234'

function PinGate({ onUnlock }) {
  const [pin, setPin]     = useState('')
  const [error, setError] = useState(false)

  const check = () => {
    if (pin === DISPLAY_PIN) {
      localStorage.setItem('display_pin_ok', DISPLAY_PIN)
      onUnlock()
    } else {
      setError(true)
      setPin('')
      setTimeout(() => setError(false), 2000)
    }
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: '#0d1b2a', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 24 }}>
      <img src="/vs-logo.png" alt="VS" style={{ height: 48, filter: 'brightness(0) invert(1)', opacity: 0.8 }} />
      <div style={{ background: '#fff', borderRadius: 16, padding: '32px 36px', width: 300, textAlign: 'center', boxShadow: '0 24px 64px rgba(0,0,0,0.5)' }}>
        <div style={{ fontSize: 14, fontWeight: 700, color: '#0d1b2a', marginBottom: 4 }}>🔒 Werkstatt-Display</div>
        <div style={{ fontSize: 12, color: '#9ca3af', marginBottom: 20 }}>PIN eingeben</div>
        <input
          type="password" inputMode="numeric" maxLength={6}
          value={pin} onChange={e => setPin(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && check()}
          autoFocus
          style={{ width: '100%', fontSize: 28, letterSpacing: 10, textAlign: 'center', border: `2px solid ${error ? '#dc2626' : '#e5e7eb'}`, borderRadius: 10, padding: '10px 0', outline: 'none', marginBottom: 14 }}
        />
        {error && <div style={{ color: '#dc2626', fontSize: 12, marginBottom: 10 }}>⚠ Falscher PIN</div>}
        <button onClick={check} style={{ width: '100%', padding: 12, background: '#ffc000', color: '#0d1b2a', border: 'none', borderRadius: 10, fontWeight: 800, fontSize: 15, cursor: 'pointer' }}>
          Entsperren
        </button>
      </div>
      <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.25)' }}>VS Automobilzentrum · Werkstatt-Display</div>
    </div>
  )
}

export default function Display() {
  const [fahrzeuge, setFahrzeuge] = useState([])
  const [time, setTime]           = useState(new Date())
  const [pinOk, setPinOk]         = useState(() => localStorage.getItem('display_pin_ok') === DISPLAY_PIN)
  const [session, setSession]     = useState(null)
  const [showLogin, setShowLogin] = useState(false)
  const [weiterFor, setWeiterFor] = useState(null)
  const [isFullscreen, setIsFullscreen] = useState(false)

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session: s } }) => setSession(s))
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_e, s) => setSession(s))
    const clock = setInterval(() => setTime(new Date()), 1000)
    const onFs = () => setIsFullscreen(!!document.fullscreenElement)
    document.addEventListener('fullscreenchange', onFs)
    return () => { clearInterval(clock); subscription.unsubscribe(); document.removeEventListener('fullscreenchange', onFs) }
  }, [])

  useEffect(() => {
    loadFahrzeuge()
    const channel = supabase
      .channel('display-realtime')
      .on('postgres_changes', { event: '*', schema: 'public', table: 'fahrzeuge' }, () => loadFahrzeuge())
      .subscribe()
    return () => supabase.removeChannel(channel)
  }, [session])

  const loadFahrzeuge = async () => {
    const { data } = await supabase
      .from('fahrzeuge').select('*').is('übergabe_ok', null)
      .order('wunschdatum', { ascending: true, nullsFirst: false })
    setFahrzeuge(data || [])
  }

  if (!pinOk) return <PinGate onUnlock={() => setPinOk(true)} />

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) document.documentElement.requestFullscreen()
    else document.exitFullscreen()
  }

  const handleWeiterClick = (f, e) => {
    e.stopPropagation()
    if (!session) { setShowLogin(true); return }
    setWeiterFor(f)
  }

  const handleZurueckClick = async (f, e) => {
    e.stopPropagation()
    if (!session) { setShowLogin(true); return }
    if (f.schritt <= 1) return
    const neu = f.schritt - 1
    await supabase.from('fahrzeuge').update({ schritt: neu }).eq('id', f.id)
    await supabase.from('schritt_historie').insert({
      fahrzeug_id: f.id, schritt: neu, typ: 'schritt',
      text: `↩ Zurück zu Schritt ${neu} (${ALLE_SCHRITTE[neu - 1].name})`,
      mitarbeiter: session?.user?.email || '',
    })
    loadFahrzeuge()
  }

  const overdue       = fahrzeuge.filter(f => f.wunschdatum && getDeadlineDiff(f.wunschdatum) < 0).length
  const kritisch      = fahrzeuge.filter(f => f.wunschdatum && getDeadlineDiff(f.wunschdatum) >= 0 && getDeadlineDiff(f.wunschdatum) <= 2).length
  const fastcarsCount = fahrzeuge.filter(f => f.fastcars).length

  return (
    <div style={S.page}>
      <style>{CSS}</style>

      {/* HEADER */}
      <div style={S.header}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 14, flex: 1, minWidth: 220 }}>
          <img src={vsLogo} alt="VS Automobilzentrum" style={{ height: 34, display: 'block' }} />
          <div>
            <div style={S.title}>Werkstatt</div>
            <div style={S.subtitle}>Live-Übersicht</div>
          </div>
        </div>
        <div style={S.statsRow}>
          {overdue > 0       && <div style={S.badge('#ef4444', '#fff')}>⚠ {overdue} Überfällig</div>}
          {kritisch > 0      && <div style={S.badge('#f59e0b', '#111')}>⏰ {kritisch} Kritisch</div>}
          {fastcarsCount > 0 && <div style={S.badge('#7c3aed', '#fff')}>🔧 {fastcarsCount} FastCars</div>}
          <div style={S.badge('#0d1b2a', '#fff')}>{fahrzeuge.length} Aktiv</div>
        </div>
        <div style={S.clockBlock}>
          <div style={S.clockTime}>
            {time.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit', second: '2-digit' })}
          </div>
          <div style={S.clockDate}>
            {time.toLocaleDateString('de-DE', { weekday: 'short', day: '2-digit', month: '2-digit', year: 'numeric' })}
          </div>
        </div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <button onClick={toggleFullscreen} title={isFullscreen ? 'Vollbild beenden' : 'Vollbild'} style={S.authBtn}>
            {isFullscreen ? '⊠' : '⛶'}
          </button>
          {session
            ? <button onClick={() => supabase.auth.signOut()} style={S.authBtn}>Abmelden</button>
            : <button onClick={() => setShowLogin(true)} style={S.authBtn}>Anmelden</button>
          }
        </div>
      </div>

      {/* FAHRZEUG-ZEILEN */}
      <div style={S.rows}>
        {fahrzeuge.length === 0 && (
          <div style={S.empty}>Keine aktiven Fahrzeuge</div>
        )}
        {fahrzeuge.map(f => {
          const tage = getTage(f.eingang)
          const diff = getDeadlineDiff(f.wunschdatum)
          const isOverdue  = diff !== null && diff < 0
          const isCritical = diff !== null && diff >= 0 && diff <= 2
          const isFc       = f.fastcars
          const stripe = isOverdue ? '#ef4444' : isCritical ? '#f59e0b' : isFc ? '#7c3aed' : 'transparent'
          const schrittName = ALLE_SCHRITTE[f.schritt - 1]?.name

          return (
            <div key={f.id} style={{ ...S.row, borderLeft: `5px solid ${stripe}` }}>
              <div style={S.colKfz}>
                <div style={S.kennzeichen}>
                  {f.kennzeichen}
                  {isFc      && <span style={S.tag('#7c3aed')}>FC</span>}
                  {f.problem && <span style={S.tag('#ef4444')}>!</span>}
                </div>
                <div style={S.fahrzeugInfo}>{f.marke} {f.modell}</div>
              </div>
              <div style={S.colSteps}>
                <StepDots schritt={f.schritt} />
                <div style={S.schrittName}>{f.schritt} · {schrittName}</div>
              </div>
              <div style={S.colTage}>
                <div style={{ fontWeight: 800, fontSize: 26, color: tage > 7 ? '#dc2626' : tage > 4 ? '#d97706' : '#16a34a', lineHeight: 1 }}>
                  {tage}<span style={{ fontSize: 13, fontWeight: 600, color: '#94a3b8' }}> Tage</span>
                </div>
                {f.wunschdatum && (
                  <div style={{ fontSize: 13, fontWeight: 700, marginTop: 4, color: isOverdue ? '#dc2626' : isCritical ? '#d97706' : '#64748b' }}>
                    {isOverdue ? `⚠ ${Math.abs(diff)}T über · ` : isCritical ? (diff === 0 ? '⏰ HEUTE · ' : `⏰ +${diff}T · `) : ''}
                    {new Date(f.wunschdatum).toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit' })}
                  </div>
                )}
              </div>
              {session && (
                <div style={{ width: 140, flexShrink: 0, display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                  <button onClick={e => handleZurueckClick(f, e)} disabled={f.schritt <= 1} title="Einen Schritt zurück" style={{
                    background: '#fff', color: f.schritt <= 1 ? '#cbd5e1' : '#475569',
                    border: `2px solid ${f.schritt <= 1 ? '#e2e8f0' : '#cbd5e1'}`,
                    borderRadius: 10, padding: '8px 13px',
                    cursor: f.schritt <= 1 ? 'default' : 'pointer', fontSize: 15, fontWeight: 800,
                  }}>←</button>
                  <button onClick={e => handleWeiterClick(f, e)} title={f.schritt === 10 ? 'Übergabe abschließen' : 'Einen Schritt weiter'} style={{
                    background: f.schritt === 10 ? '#16a34a' : C.primary,
                    color: f.schritt === 10 ? '#fff' : C.onPrimary,
                    border: 'none', borderRadius: 10, padding: '8px 15px',
                    cursor: 'pointer', fontSize: 15, fontWeight: 800, whiteSpace: 'nowrap',
                  }}>
                    {f.schritt === 10 ? '✓' : '→'}
                  </button>
                </div>
              )}
            </div>
          )
        })}
      </div>

      <div style={S.footer}>
        <span>VS Automobilzentrum · Werkstatt – Lack – Karosserie</span>
        <span>{fahrzeuge.length} Fahrzeuge in Bearbeitung</span>
      </div>

      {showLogin && <LoginModal onSuccess={() => setShowLogin(false)} onClose={() => setShowLogin(false)} />}
      {weiterFor && (
        <WeiterModal
          fahrzeug={weiterFor}
          mitarbeiter={session?.user?.email || ''}
          onClose={() => setWeiterFor(null)}
          onDone={() => { setWeiterFor(null); loadFahrzeuge() }}
        />
      )}
    </div>
  )
}

const ml = { display: 'block', fontSize: 14, fontWeight: 600, color: '#374151', marginBottom: 6 }
const mi = { width: '100%', padding: '11px 14px', border: '1.5px solid #d1d5db', borderRadius: 10, fontSize: 16, boxSizing: 'border-box' }

const S = {
  page: {
    minHeight: '100vh',
    background: 'linear-gradient(160deg, #f1f5f9 0%, #e2e8f0 60%, #f1f5f9 100%)',
    color: '#0d1b2a', fontFamily: "'Segoe UI', Arial, sans-serif",
    display: 'flex', flexDirection: 'column', padding: '14px 22px', gap: 10,
  },
  header: {
    display: 'flex', alignItems: 'center', gap: 16,
    padding: '4px 4px 10px', borderBottom: `3px solid ${C.primary}`,
    flexWrap: 'wrap', width: '100%', maxWidth: 1500, margin: '0 auto',
  },
  title:    { fontSize: 22, fontWeight: 800, color: '#0d1b2a', letterSpacing: 0.4 },
  subtitle: { fontSize: 12, color: '#64748b', marginTop: 1 },
  statsRow: { display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' },
  badge:    (bg, color) => ({ background: bg, color, borderRadius: 8, padding: '5px 12px', fontSize: 14, fontWeight: 800 }),
  clockBlock: { textAlign: 'right', flexShrink: 0, background: '#0d1b2a', borderRadius: 12, padding: '8px 16px' },
  clockTime: { fontSize: 30, fontWeight: 800, color: C.primary, letterSpacing: 2, fontVariantNumeric: 'tabular-nums', lineHeight: 1 },
  clockDate: { fontSize: 11, color: '#94a3b8', marginTop: 3 },
  authBtn:  { background: '#fff', color: '#64748b', border: '1px solid #cbd5e1', borderRadius: 8, padding: '6px 13px', cursor: 'pointer', fontSize: 13, flexShrink: 0 },
  rows: { flex: 1, display: 'flex', flexDirection: 'column', gap: 10, minHeight: 0, width: '100%', maxWidth: 1500, margin: '0 auto' },
  row: {
    flex: 1, minHeight: 64, maxHeight: 130,
    display: 'flex', alignItems: 'center', gap: 18,
    background: '#ffffff', border: '1px solid #e8edf3',
    borderRadius: 14, padding: '10px 20px',
    boxShadow: '0 2px 10px rgba(13,27,42,0.07)',
  },
  colKfz:       { width: 250, flexShrink: 0 },
  kennzeichen:  { fontSize: 25, fontWeight: 900, letterSpacing: 1, color: '#0d1b2a', display: 'flex', alignItems: 'center', gap: 8 },
  fahrzeugInfo: { fontSize: 14, color: '#64748b', marginTop: 3 },
  colSteps:     { flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 7, minWidth: 0 },
  schrittName:  { fontSize: 14, fontWeight: 800, color: '#0d1b2a', letterSpacing: 0.4, background: C.primarySoft, border: `1px solid ${C.primary}`, borderRadius: 7, padding: '2px 12px' },
  colTage:      { width: 150, flexShrink: 0, textAlign: 'right' },
  tag:          (bg) => ({ background: bg, color: '#fff', borderRadius: 5, padding: '2px 8px', fontSize: 12, fontWeight: 800 }),
  empty:        { textAlign: 'center', padding: 48, color: '#94a3b8', fontSize: 17 },
  footer:       { display: 'flex', justifyContent: 'space-between', padding: '4px 6px', fontSize: 12, color: '#94a3b8', width: '100%', maxWidth: 1500, margin: '0 auto' },
}
